import React from 'react';
import { motion } from 'framer-motion';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';

const FAQ = () => {
  const faqs = [
    {
      question: 'What happens to denied claims?',
      answer: 'Our denial management team immediately investigates every denied claim, corrects any issues, and resubmits within 48 hours. We also appeal unjust denials and track denial patterns to prevent future rejections. Our 95%+ first-pass acceptance rate means fewer denials to begin with.',
    },
    {
      question: 'Can you integrate with our existing EHR?',
      answer: 'Yes! We integrate seamlessly with all major EHR and practice management systems including Epic, athenahealth, eClinicalWorks, AdvancedMD, Kareo, DrChrono, and many others. Our technical team handles the entire integration process, typically completed within 1-2 weeks.',
    },
    {
      question: 'How is pricing calculated?',
      answer: 'We charge a percentage of your monthly collections (typically 3-8%), with the exact rate based on your practice size, specialty complexity, and claim volume. There are no upfront costs, setup fees, or hidden charges. You only pay when we collect for you, aligning our success with yours.',
    },
    {
      question: 'How do we switch billing companies without disruption?',
      answer: 'We have a proven transition process that ensures zero disruption to your revenue cycle. Our team coordinates with your current billing company, takes over work-in-progress claims, and ensures all outstanding AR is collected. Most practices see improved cash flow within the first billing cycle.',
    },
    {
      question: 'What kind of reporting do you provide?',
      answer: 'You get 24/7 access to a real-time dashboard showing claims status, AR aging, collection rates, denial rates, and revenue trends. Your dedicated account manager also provides monthly performance reviews and strategic recommendations.',
    },
    {
      question: 'Do you handle patient billing and collections?',
      answer: 'Yes! We manage the entire patient billing process including statement generation, payment processing, payment plans, and professional collections. Our patient-friendly approach maintains positive relationships while maximizing collections.',
    },
  ];

  return (
    <section id="faq" className="py-32 bg-white">
      <div className="container mx-auto px-6 max-w-4xl">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <div className="text-[#14b8a6] font-semibold text-sm tracking-wider uppercase mb-4">
            Questions & Answers
          </div>
          <h2 className="text-5xl lg:text-6xl font-bold text-slate-900 mb-6">
            Frequently Asked Questions
          </h2>
          <p className="text-xl text-slate-600">
            Everything you need to know about partnering with Bill Well Benefits
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, index) => (
              <AccordionItem
                key={index}
                value={`item-${index}`}
                className="border-2 border-slate-100 rounded-xl px-6 hover:border-[#14b8a6]/30 transition-all duration-300 data-[state=open]:border-[#14b8a6]/50 data-[state=open]:shadow-lg"
              >
                <AccordionTrigger className="text-left text-lg font-semibold text-slate-900 hover:text-[#1e3a8a] py-6 hover:no-underline">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-slate-600 leading-relaxed text-base pb-6">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
};

export default FAQ;
